var map = {
	"./business.svg": 5528,
	"./design.svg": 3348,
	"./diamond.svg": 5710,
	"./facebook.png": 5260,
	"./facebook.webp": 7422,
	"./feature.png": 8552,
	"./feature.webp": 8888,
	"./finance.svg": 6764,
	"./google.png": 7597,
	"./google.webp": 8857,
	"./human.svg": 4193,
	"./icons8-bill-100.png": 5764,
	"./icons8-bill-100.webp": 6220,
	"./icons8-lock.svg": 2308,
	"./intel.png": 2250,
	"./intel.webp": 6642,
	"./location.svg": 9915,
	"./man-model.png": 5382,
	"./man-model.webp": 2102,
	"./microsoft.png": 6410,
	"./microsoft.webp": 818,
	"./mobile.svg": 2212,
	"./nadya_bella.jpg": 884,
	"./nadya_bella.webp": 1624,
	"./natalia_polyska.jpg": 3890,
	"./natalia_polyska.webp": 7886,
	"./nicky_amanda.jpg": 1015,
	"./nicky_amanda.webp": 3791,
	"./plus.svg": 4066,
	"./ptolemy_dunkley.jpg": 9277,
	"./ptolemy_dunkley.webp": 7715,
	"./rico_mayer.jpg": 2374,
	"./rico_mayer.webp": 9516,
	"./support.svg": 8923,
	"./suzannah_baker.jpg": 958,
	"./suzannah_baker.webp": 788,
	"./triangle.svg": 2566,
	"./web.svg": 5828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;